// hooks/useTelegram.js
import {useEffect} from 'react';

const tg = window.Telegram?.WebApp;

export function useTelegram() {
    useEffect(() => {
        if (tg) {
            tg.ready(); // Сообщаем клиенту, что приложение готово
        }
    }, []);

    const onClose = () => {
        if (tg) {
            tg.close();
        }
    };

    const getUser = () => {
        return tg?.initDataUnsafe?.user;
    };

    const getUserLanguage = () => {
        if (!tg) return 'en';
        return (tg.initDataUnsafe?.user?.language_code || tg.platform) || 'en';
    };

    const requestContact = () => {
        if (tg) {
            return tg.requestContact();
        }
        return null;
    };

    const sendData = (data) => {
        if (tg) {
            tg.ready();
            tg.sendData(JSON.stringify(data));
            tg.close();
            console.log('Data sent:', JSON.stringify(data));
            return true;
        }
        return false;
    };

    return {
        tg,
        tg_user: getUser(),
        tg_language: getUserLanguage(),
        onClose,
        requestContact,
        sendData
    };
}